/* Live view count for sections/hc-checklist-app.liquid.
   Every page load counts as one view (any person, any device, any time).
   While the page is open the number refreshes every 20 seconds, so new views tick in live.
   The count lives in a free Abacus counter (abacus.jasoncameron.dev); if it can't be reached the badge stays hidden. */
(function () {
  var wraps = document.querySelectorAll('[data-hc-views-wrap]');
  if (!wraps.length || !window.fetch) return;
  var API = 'https://abacus.jasoncameron.dev', KEY = 'gethighconvert/cro-checklist-views';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, current = 0;

  function fmt(n) { return n.toLocaleString('en'); }
  function countTo(el, from, to) {
    if (reduce || to - from < 2) { el.textContent = fmt(to); return; }
    var t0 = performance.now(), dur = Math.min(1400, 400 + (to - from) * 8);
    (function step(now) {
      var p = Math.min(1, (now - t0) / dur), v = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
      el.textContent = fmt(v);
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }
  function show(n) {
    var from = current; current = n;
    wraps.forEach(function (w) {
      if (n < (+w.getAttribute('data-min') || 1)) return;
      var first = w.hidden; w.hidden = false;
      w.querySelectorAll('[data-hc-views]').forEach(function (el) { countTo(el, first ? 0 : from, n); });
      w.querySelectorAll('[data-hc-views-noun]').forEach(function (el) { el.textContent = n === 1 ? 'view' : 'views'; });
      if (!first && n > from) {
        var bump = w.querySelector('[data-hc-views-bump]');
        if (bump) { bump.textContent = '+' + (n - from); bump.classList.remove('is-on'); void bump.offsetWidth; bump.classList.add('is-on'); }
      }
    });
  }
  function load(path) {
    return fetch(API + path + KEY, { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && typeof d.value === 'number' && d.value >= current) show(d.value); })
      .catch(function () {});
  }

  load('/hit/');
  setInterval(function () { if (!document.hidden) load('/get/'); }, 20000);
})();
